import { Card, Flex } from "@radix-ui/themes";

import { LayoutSettingsSectionPresentation } from "./LayoutSettingsSection.pres";
import type { LayoutSettingsPanelPresentationProps } from "./layoutSettings.types";

export const LayoutSettingsPanelPresentation = ({
  expanded,
  panelId,
  labelledBy,
  sections,
  onFieldChange,
}: LayoutSettingsPanelPresentationProps) => {
  if (!expanded) {
    return null;
  }

  return (
    // Radix Card is the surface; we hand it `role="region"` + the panel ids
    // so screen readers announce the panel and the toolbar button remains
    // its explicit label.
    <Card size="1" role="region" id={panelId} aria-labelledby={labelledBy}>
      <Flex direction="column" gap="3">
        {sections.map((sec) => (
          <LayoutSettingsSectionPresentation
            key={sec.id}
            panelId={panelId}
            section={sec}
            onFieldChange={onFieldChange}
          />
        ))}
      </Flex>
    </Card>
  );
};
